import { ICON__chart_diagram_solid } from '@/assets/icons_fa';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { store_local__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { CONTEXT_MENU_ITEM__field_base } from '../_base/CONTEXT_MENU_ITEM__field_base';

interface PROPS {
  field: FIELD__base;
}

export function CONTEXT_MENU_ITEM__field_locate({ field }: PROPS) {
  const { g_general__layout } = use_slice_ui(['g_general__layout']);

  /*
   * EVENTS
   */

  async function on_click() {
    store_local__ui_set_string({ key: 'g_general__layout', value: ENUM__page_generation_layout.NODES, valid_values: [] });

    UTILS__graph_ui.node__select(field.meta.node_id);
  }

  /*
   * HTML
   */

  if (g_general__layout == ENUM__page_generation_layout.NODES) return null;

  return <CONTEXT_MENU_ITEM__field_base Icon={ICON__chart_diagram_solid} {...{ on_click }} text={'Locate in graph'} />;
}
